import * as THREE from '../../libs/three.js/build/three.module.js';
import { EventDispatcher } from '../EventDispatcher.js';

// Icons for the slide-out map control panels (single-color, inherit currentColor).
const NOACH_MAP_ICON_WMS =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>';
const NOACH_MAP_ICON_FLOORS =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="1"/><path d="M3 9h6V3M21 15h-6v6M9 9v6h6"/></svg>';

// http://epsg.io/
proj4.defs([
  ['UTM10N', '+proj=utm +zone=10 +ellps=GRS80 +datum=NAD83 +units=m +no_defs'],
  ['EPSG:6339', '+proj=utm +zone=10 +ellps=GRS80 +units=m +no_defs'],
  ['EPSG:6340', '+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs'],
  ['EPSG:6341', '+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs'],
  ['EPSG:6342', '+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs'],
  ['EPSG:6343', '+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs'],
  ['EPSG:6344', '+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs'],
  ['EPSG:6345', '+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs'],
  ['EPSG:6346', '+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs'],
  ['EPSG:6347', '+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs'],
  ['EPSG:6348', '+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs'],
  [
    'EPSG:26910',
    '+proj=utm +zone=10 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ',
  ],
  [
    'EPSG:26911',
    '+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ',
  ],
  [
    'EPSG:26912',
    '+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ',
  ],
  [
    'EPSG:26913',
    '+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ',
  ],
  [
    'EPSG:26914',
    '+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ',
  ],
  [
    'EPSG:26915',
    '+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ',
  ],
  [
    'EPSG:26916',
    '+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ',
  ],
  [
    'EPSG:26917',
    '+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ',
  ],
  [
    'EPSG:26918',
    '+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ',
  ],
  [
    'EPSG:26919',
    '+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ',
  ],
]);

export class MapView extends EventDispatcher {
  constructor(viewer) {
    super();
    this.viewer = viewer;

    this.webMapService = 'WMTS';
    this.mapProjectionName = 'EPSG:3857';
    this.mapProjection = proj4.defs(this.mapProjectionName);
    this.sceneProjection = null;
    this.localMode = false;

    this.extentsLayer = null;
    this.cameraLayer = null;
    this.toolLayer = null;
    this.sourcesLayer = null;
    this.sourcesLabelLayer = null;
    this.images360Layer = null;
    this.enabled = false;
    this.KMLLayer = null;
    this._floorsInserted = 0;

    // this.createAnnotationStyle = (text) => {
    //   return [
    //     new ol.style.Style({
    //       image: new ol.style.Circle({
    //         radius: 10,
    //         stroke: new ol.style.Stroke({
    //           color: [255, 255, 255, 0.5],
    //           width: 2,
    //         }),
    //         fill: new ol.style.Fill({
    //           color: [0, 0, 0, 0.5],
    //         }),
    //       }),
    //     }),
    //   ];
    // };

    this.createLabelStyle = (text) => {
      let style = new ol.style.Style({
        image: new ol.style.Circle({
          radius: 6,
          stroke: new ol.style.Stroke({
            color: 'white',
            width: 2,
          }),
          fill: new ol.style.Fill({
            color: 'green',
          }),
        }),
        text: new ol.style.Text({
          font: '12px helvetica,sans-serif',
          text: text,
          fill: new ol.style.Fill({
            color: '#000',
          }),
          stroke: new ol.style.Stroke({
            color: '#fff',
            width: 2,
          }),
        }),
      });

      return style;
    };
  }

  set floorsInserted(floorsInserted) {
    if (this._floorsInserted === floorsInserted) {
      return;
    }
    this._floorsInserted = floorsInserted;
  }

  get floorsInserted() {
    return this._floorsInserted;
  }

  showSources(show) {
    this.sourcesLayer.setVisible(show);
    this.sourcesLabelLayer.setVisible(show);
  }

  init() {
    if (typeof ol === 'undefined') {
      return;
    }
    this.elMap = $('#potree_map');
    this.elMap.draggable({ handle: $('#potree_map_header, #potree_map .potree-dialog-titlebar') });
    this.elMap.resizable();

    $('#potree_map_close').on('click', () => this.toggle());

    this.elTooltip = $(`<div style="position: relative; z-index: 100"></div>`);
    this.elMap.append(this.elTooltip);

    let extentsLayer = this.getExtentsLayer();
    let cameraLayer = this.getCameraLayer();
    this.getToolLayer();
    let sourcesLayer = this.getSourcesLayer();
    this.images360Layer = this.getImages360Layer();
    this.KMLLayer = this.getKMLLayer();
    this.getSourcesLabelLayer();
    // this.getAnnotationsLayer();

    let mousePositionControl = new ol.control.MousePosition({
      coordinateFormat: ol.coordinate.createStringXY(5),
      projection: 'EPSG:4326',
      undefinedHTML: '&nbsp;',
    });

    let _this = this;
    let DownloadSelectionControl = function (optOptions) {
      let options = optOptions || {};

      // TOGGLE TILES
      let btToggleTiles = document.createElement('button');
      btToggleTiles.innerHTML = 'T';
      btToggleTiles.addEventListener(
        'click',
        () => {
          let visible = sourcesLayer.getVisible();
          _this.showSources(!visible);
        },
        false
      );
      btToggleTiles.style.float = 'left';
      btToggleTiles.title = 'show / hide tiles';

      // DOWNLOAD SELECTED TILES
      let link = document.createElement('a');
      link.href = '#';
      link.download = 'list.txt';
      link.style.float = 'left';

      let button = document.createElement('button');
      button.innerHTML = 'D';
      link.appendChild(button);

      let handleDownload = (e) => {
        let features = selectedFeatures.getArray();

        let url = [
          document.location.protocol,
          '//',
          document.location.host,
          document.location.pathname,
        ].join('');

        if (features.length === 0) {
          alert(
            'No tiles were selected. Select area with ctrl + left mouse button!'
          );
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        } else if (features.length === 1) {
          let feature = features[0];

          if (feature.source) {
            let cloudjsurl = feature.pointcloud.pcoGeometry.url;
            let sourceurl = new URL(
              url + '/../' + cloudjsurl + '/../source/' + feature.source.name
            );
            link.href = sourceurl.href;
            link.download = feature.source.name;
          }
        } else {
          let content = '';
          for (let i = 0; i < features.length; i++) {
            let feature = features[i];

            if (feature.source) {
              let cloudjsurl = feature.pointcloud.pcoGeometry.url;
              let sourceurl = new URL(
                url + '/../' + cloudjsurl + '/../source/' + feature.source.name
              );
              content += sourceurl.href + '\n';
            }
          }

          let uri = 'data:application/octet-stream;base64,' + btoa(content);
          link.href = uri;
          link.download = 'list_of_files.txt';
        }
      };

      button.addEventListener('click', handleDownload, false);

      // assemble container
      let element = document.createElement('div');
      element.className = 'ol-unselectable ol-control';
      element.id = 'download-selection-control';
      // element.appendChild(link);
      // element.appendChild(btToggleTiles);
      element.style.bottom = '0.5em';
      element.style.left = '0.5em';
      element.title =
        'Download file or list of selected tiles. Select tile with left mouse button or area using ctrl + left mouse.';

      ol.control.Control.call(this, {
        element: element,
        target: options.target,
      });
    };

    ol.inherits(DownloadSelectionControl, ol.control.Control);
    this.map = new ol.Map({
      controls: ol.control
        .defaults({
          attributionOptions: {
            collapsible: false,
          },
        })
        .extend([
          // this.controls.zoomToExtent,
          new DownloadSelectionControl(),
          mousePositionControl,
        ]),
      layers: [
        new ol.layer.Tile({ source: new ol.source.OSM() }),
        // tu są wmsy
        this.toolLayer,
        // this.annotationsLayer,
        this.sourcesLayer,
        this.sourcesLabelLayer,
        this.images360Layer,
        this.KMLLayer,
        extentsLayer,
        cameraLayer,
      ],
      target: 'potree_map_content',
      view: new ol.View({
        center: this.olCenter,
        zoom: 9,
      }),
    });

    // WMS from HTML
    // let htmlInvokedLayer;
    // if (this.viewer.WMS !== '') {
    //   htmlInvokedLayer = new ol.layer.Image({
    //     className: 'background',
    //     opacity: 1,
    //     source: new ol.source.ImageWMS({
    //       url: this.viewer.WMS,
    //       params: {
    //         layers: 'Raster',
    //       },
    //     }),
    //   });
    //   this.map.getLayers().insertAt(1, htmlInvokedLayer);
    // }

    // WMS sources (konfiguracja)
    const wmsSources = [
      {
        name: 'Domyślny',
        url: '',
      },
      {
        name: 'TrueOrtho',
        url: 'https://mapy.geoportal.gov.pl/wss/service/PZGIK/ORTO/WMS/TrueOrtho',
        layers: 'PrawdziwaOrtofotomapa',
        version: '1.3.0'
      },
      {
        name: 'Osnowa Grawimetryczna',
        url: 'https://mapy.geoportal.gov.pl/wss/service/PZGIK/OsnowaGrawimetryczna',
        layers: 'Fundamentalna_grawimetryczna,Fudnamentalna_grawimetryczna_etykiety,Bazowa_grawimetryczna,Bazowa_grawimetryczna_etykiety',
        version: '1.3.0'
      },
      {
        name: 'Osnowa Magnetyczna',
        url: 'https://mapy.geoportal.gov.pl/wss/service/PZGIK/OsnowaMagnetyczna',
        layers: 'izogony_etykiety,izogony,Fundamentalna_magnetyczna,Fudnamentalna_magnetyczna_etykiety,Bazowa_magnetyczna,Bazowa_magnetyczna_etykiety',
        version: '1.3.0'
      },
      {
        name: 'Osnowa Geodezyjna Pozioma',
        url: 'https://mapy.geoportal.gov.pl/wss/service/PZGIK/PodstawowaOsnowaGeodezyjnaPozioma',
        layers: 'Fundamentalna_pozioma,Fudnamentalna_pozioma_etykiety,Bazowa_pozioma,Bazowa_pozioma_etykiety',
        version: '1.3.0'
      },
      {
        name: 'HYDRO',
        url: 'https://mapy.geoportal.gov.pl/wss/service/img/guest/HYDRO/MapServer/WMSServer',
        layers: 'Raster,Raster_enviDMS_50k,Raster_enviDMS_10k',
        version: '1.3.0'
      },
      {
        name: 'Krajowa Integracja Ewidencji Gruntow',
        url: 'https://integracja.gugik.gov.pl/cgi-bin/KrajowaIntegracjaEwidencjiGruntow',
        layers: 'powiaty,powiaty_obreby,powiaty_uzytki,ekw,regon,pesel,zsin,obreby,dzialki,geoportal,numery_dzialek,budynki,kontury,uzytki',
        version: '1.3.0'
      },
      {
        name: 'Krajowa Integracja Miejscowych Planów Zagospodarowania Przestrzennego',
        url: 'https://mapy.geoportal.gov.pl/wss/ext/KrajowaIntegracjaMiejscowychPlanowZagospodarowaniaPrzestrzennego',
        layers: 'plany,plany_granice,raster,wektor-str,wektor-lzb,wektor-pow,wektor-lin,wektor-pkt,granice',
        version: '1.3.0'
      }
    ];

    // UI: lista WMS jako przyciski inline (bez select)
    const WMSGroup = document.createElement('div');
    WMSGroup.className = 'noach-map-list';

    const applyWMS = (index) => {
      const layers = this.map.getLayers().getArray();
      const layerAt1 = layers[1];
      if (layerAt1 && layerAt1 instanceof ol.layer.Image && layerAt1.get('isWMS')) {
        this.map.getLayers().removeAt(1);
      }
      const selected = wmsSources[index];
      if (!selected || !selected.url) return;
      const newWMSLayer = new ol.layer.Image({
        className: 'background',
        opacity: 1,
        source: new ol.source.ImageWMS({
          url: selected.url,
          params: { LAYERS: selected.layers, VERSION: selected.version },
          ratio: 1,
          crossOrigin: 'anonymous',
        }),
      });
      newWMSLayer.set('isWMS', true);
      this.map.getLayers().insertAt(1, newWMSLayer);
    };

    wmsSources.forEach((source, index) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'noach-map-list-item';
      btn.dataset.value = String(index);
      btn.textContent = source.name;
      btn.addEventListener('click', () => {
        const isActive = btn.classList.contains('active');
        // deselect all
        for (const b of WMSGroup.querySelectorAll('.noach-map-list-item')) {
          b.classList.remove('active');
        }
        if (isActive) {
          // toggle off — remove WMS layer
          const layerAt1 = this.map.getLayers().getArray()[1];
          if (layerAt1 && layerAt1 instanceof ol.layer.Image && layerAt1.get('isWMS')) {
            this.map.getLayers().removeAt(1);
          }
        } else {
          btn.classList.add('active');
          applyWMS(index);
        }
      });
      WMSGroup.appendChild(btn);
    });

    // Dodaj grupę do UI: wysuwany panel z prawej strony mapy (zamiast stałej
    // listy zasłaniającej mapę). Fallback do starego kontenera, jeśli panele
    // nie są dostępne.
    const mapPanels = this._ensureMapPanels();
    if (mapPanels) {
      mapPanels.setPanelContent('wms', WMSGroup, {
        label: 'Podkład mapy',
        title: 'Podkład mapy',
        icon: NOACH_MAP_ICON_WMS,
      });
    } else {
      document.getElementById('download-selection-control').appendChild(WMSGroup);
    }

    // DRAGBOX / SELECTION
    this.dragBoxLayer = new ol.layer.Vector({
      source: new ol.source.Vector({}),
      style: new ol.style.Style({
        stroke: new ol.style.Stroke({
          color: 'rgba(0, 0, 255, 1)',
          width: 2,
        }),
      }),
    });
    this.map.addLayer(this.dragBoxLayer);

    let select = new ol.interaction.Select();
    this.map.addInteraction(select);

    let selectedFeatures = select.getFeatures();

    let dragBox = new ol.interaction.DragBox({
      condition: ol.events.condition.platformModifierKeyOnly,
    });

    this.map.addInteraction(dragBox);

    // this.map.on('pointermove', evt => {
    // 	let pixel = evt.pixel;
    // 	let feature = this.map.forEachFeatureAtPixel(pixel, function (feature) {
    // 		return feature;
    // 	});

    // 	// this.elTooltip.css("display", feature ? '' : 'none');
    // 	this.elTooltip.css('display', 'none');
    // 	if (feature && feature.onHover) {
    // 		feature.onHover(evt);
    // 		// overlay.setPosition(evt.coordinate);
    // 		// tooltip.innerHTML = feature.get('name');
    // 	}
    // });

    this.map.on('click', (evt) => {
      let pixel = evt.pixel;
      let feature = this.map.forEachFeatureAtPixel(pixel, function (feature) {
        return feature;
      });

      if (feature && feature.onClick) {
        feature.onClick(evt);
      }
    });

    dragBox.on('boxend', (e) => {
      // features that intersect the box are added to the collection of
      // selected features, and their names are displayed in the "info"
      // div
      let extent = dragBox.getGeometry().getExtent();
      this.getSourcesLayer()
        .getSource()
        .forEachFeatureIntersectingExtent(extent, (feature) => {
          selectedFeatures.push(feature);
        });
    });

    // clear selection when drawing a new box and when clicking on the map
    dragBox.on('boxstart', (e) => {
      selectedFeatures.clear();
    });
    this.map.on('click', () => {
      selectedFeatures.clear();
    });

    this.viewer.addEventListener('scene_changed', (e) => {
      this.setScene(e.scene);
    });

    this.onPointcloudAdded = (e) => {
      this.load(e.pointcloud);
    };

    this.on360ImagesAdded = (e) => {
      this.addImages360(e.images);
    };

    this.onKMLAdded = (e) => {
      this.setKMLLayerSource(e.KML.url);
    };

    // this.onAnnotationAdded = (e) => {
    //   if (!this.sceneProjection) {
    //     return;
    //   }

    //   let annotation = e.annotation;
    //   let position = annotation.position;
    //   let mapPos = this.toMap.forward([position.x, position.y]);
    //   let feature = new ol.Feature({
    //     geometry: new ol.geom.Point(mapPos),
    //     name: annotation.title,
    //   });
    //   feature.setStyle(this.createAnnotationStyle(annotation.title));

    //   feature.onHover = (evt) => {
    //     let coordinates = feature.getGeometry().getCoordinates();
    //     let p = this.map.getPixelFromCoordinate(coordinates);

    //     this.elTooltip.html(annotation.title);
    //     this.elTooltip.css('display', '');
    //     this.elTooltip.css('left', `${p[0]}px`);
    //     this.elTooltip.css('top', `${p[1]}px`);
    //   };

    //   feature.onClick = (evt) => {
    //     annotation.clickTitle();
    //   };

    //   this.getAnnotationsLayer().getSource().addFeature(feature);
    // };

    this.map.addEventListener('floor-display', (e) => {
      if (e.floor != null) {
        for (let i = 1; i <= this._floorsInserted + 1; i++) {
          this.map.getLayers().getArray()[i].setVisible(true);
        }
        for (let i = 1; i <= this._floorsInserted + 1; i++) {
          if (i - 1 != e.floor) {
            this.map.getLayers().getArray()[i].setVisible(false);
          }
        }
        this._selectFloor?.(String(e.floor));
      }
    });

    let upButton = document.createElement('input');
    upButton.type = 'button';
    upButton.style.backgroundColor = '#fafafa';
    upButton.style.width = '45px';
    upButton.style.height = '45px';
    upButton.style.fontWeight = '0.2em';
    this.upButton = upButton;
    this.domRoot = viewer.renderer.domElement.parentElement;
    this.domRoot.appendChild(upButton);
    upButton.style.display = '';

    let downButton = document.createElement('input');
    downButton.type = 'button';
    downButton.style.backgroundColor = '#fafafa';
    downButton.style.width = '45px';
    downButton.style.height = '45px';
    downButton.style.fontWeight = '0.2em';
    this.downButton = downButton;
    this.domRoot = viewer.renderer.domElement.parentElement;
    this.domRoot.appendChild(downButton);
    downButton.style.display = '';

    this.setScene(this.viewer.scene);
  }

  /**
   * Build (once) the slide-out control UI inside the map: a small button rail in
   * the top-right corner and a single drawer that slides in from the right edge
   * at full map height. Only one panel is shown at a time, so the controls stop
   * permanently covering the map. Returns an API object or null if the map
   * content host isn't present.
   */
  _ensureMapPanels() {
    if (this._mapPanels) return this._mapPanels;

    // Rail (toggle buttons) lives inside the map viewport — top-right corner.
    const mapContent = document.getElementById('potree_map_content');
    // Drawer clip is mounted on the map dialog (overflow:visible) so it can
    // extend to the right without being clipped by #potree_map_content's
    // overflow:hidden. A CSS variable carries the titlebar height so the clip
    // aligns flush with the top of the map content.
    const mapDialog = document.getElementById('potree_map');
    if (!mapContent || !mapDialog) return null;

    const rail = document.createElement('div');
    rail.className = 'noach-map-rail';

    const drawerClip = document.createElement('div');
    drawerClip.className = 'noach-map-drawer-clip';

    const drawer = document.createElement('div');
    drawer.className = 'noach-map-drawer';

    const header = document.createElement('div');
    header.className = 'noach-map-drawer-header';
    const titleEl = document.createElement('span');
    titleEl.className = 'noach-map-drawer-title';
    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'noach-map-drawer-close';
    closeBtn.innerHTML = '&#x2715;';
    closeBtn.title = 'Zamknij';
    header.appendChild(titleEl);
    header.appendChild(closeBtn);

    const body = document.createElement('div');
    body.className = 'noach-map-drawer-body';

    drawer.appendChild(header);
    drawer.appendChild(body);
    drawerClip.appendChild(drawer);

    mapContent.appendChild(rail);
    mapDialog.appendChild(drawerClip);

    // Measure the titlebar now that it is rendered and expose the height as a
    // CSS custom property so the clip starts flush with the map viewport.
    const titlebarEl = mapDialog.querySelector('.potree-dialog-titlebar');
    const titlebarH = titlebarEl ? titlebarEl.offsetHeight : 45;
    mapDialog.style.setProperty('--noach-map-titlebar-h', `${titlebarH}px`);

    const panels = {};

    const api = {
      activeKey: null,
      close: () => {
        api.activeKey = null;
        drawer.classList.remove('open');
        for (const k of Object.keys(panels)) panels[k].button.classList.remove('active');
      },
      open: (key) => {
        if (!panels[key]) return;
        if (api.activeKey === key) {
          api.close();
          return;
        }
        api.activeKey = key;
        for (const k of Object.keys(panels)) {
          const isActive = k === key;
          panels[k].button.classList.toggle('active', isActive);
          panels[k].section.style.display = isActive ? '' : 'none';
        }
        titleEl.textContent = panels[key].title;
        drawer.classList.add('open');
      },
      setPanelContent: (key, el, meta = {}) => {
        let p = panels[key];
        if (!p) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'noach-map-rail-btn';
          button.addEventListener('click', () => api.open(key));
          rail.appendChild(button);

          const section = document.createElement('div');
          section.className = 'noach-map-panel';
          section.style.display = 'none';
          body.appendChild(section);

          p = panels[key] = { button, section, title: meta.title || meta.label || '' };
        }
        if (meta.icon) p.button.innerHTML = meta.icon;
        if (meta.label) p.button.title = meta.label;
        if (meta.title) p.title = meta.title;
        if (api.activeKey === key) titleEl.textContent = p.title;
        p.section.innerHTML = '';
        if (el) p.section.appendChild(el);
      },
      showButton: (key, show) => {
        const p = panels[key];
        if (!p) return;
        p.button.style.display = show ? '' : 'none';
        if (!show && api.activeKey === key) api.close();
      },
    };

    closeBtn.addEventListener('click', api.close);
    this._mapPanels = api;
    return api;
  }

  createFloorsOnMap() {
    const floorsGroup = document.createElement('div');
    floorsGroup.className = 'noach-map-list';

    const selectFloor = (value) => {
      if (value === 'all') {
        for (let i = 1; i <= this._floorsInserted + 1; i++) {
          this.map.getLayers().getArray()[i].setVisible(false);
        }
        for (let images of this.scene.images360) {
          images.dispatchEvent({ type: 'floor-changed', floor: Infinity });
        }
      } else {
        const num = parseInt(value);
        for (let i = 1; i <= this._floorsInserted + 1; i++) {
          this.map.getLayers().getArray()[i].setVisible(i === num + 1);
        }
        for (let images of this.scene.images360) {
          images.dispatchEvent({ type: 'floor-changed', floor: num });
        }
      }
      for (const btn of floorsGroup.querySelectorAll('.noach-map-list-item')) {
        btn.classList.toggle('active', btn.dataset.value === value);
      }
    };

    this._selectFloor = selectFloor;

    const allBtn = document.createElement('button');
    allBtn.type = 'button';
    allBtn.className = 'noach-map-list-item active';
    allBtn.dataset.value = 'all';
    allBtn.textContent = 'Wszystko';
    allBtn.addEventListener('click', () => selectFloor('all'));
    floorsGroup.appendChild(allBtn);

    for (let i = 0; i < this._floorsInserted; i++) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'noach-map-list-item';
      btn.dataset.value = String(i);
      btn.textContent = 'Piętro ' + i;
      btn.addEventListener('click', () => selectFloor(String(i)));
      floorsGroup.appendChild(btn);
    }

    this.floorsList = floorsGroup;
    return floorsGroup;
  }

  floorVisible(dir) {
    if (dir === 'up') {
      for (let i = 1; i <= this._floorsInserted; i++) {
        if (
          this.map.getLayers().getArray()[i].getVisible() &&
          !this.map.getLayers().getArray()[i + 1].getVisible()
        ) {
          this.map.getLayers().getArray()[i].setVisible(false);
          this.map.getLayers().getArray()[i + 1].setVisible(true);
          return i;
        }
      }
    } else if (dir === 'down') {
      for (let i = 1; i <= this._floorsInserted; i++) {
        if (
          !this.map.getLayers().getArray()[i].getVisible() &&
          this.map.getLayers().getArray()[i + 1].getVisible()
        ) {
          this.map.getLayers().getArray()[i].setVisible(true);
          this.map.getLayers().getArray()[i + 1].setVisible(false);
          return i - 1;
        }
      }
    }
    return -1;
  }

  changeFloor(dir) {
    if (dir !== 'up' && dir !== 'down') {
      return;
    }
    let floor = this.floorVisible(dir);
    if (floor === -1) {
      return;
    }
    this.scene.images360.images.dispatchEvent({
      type: 'floor-changed',
      floor: floor,
    });
  }

  setScene(scene) {
    if (this.scene === scene) {
      return;
    }

    // Drop any 360-image sets queued for the previous scene — otherwise a
    // later setSceneProjection/setLocalMode flush would add markers for sets
    // that belong to a scene we've switched away from (ghost markers).
    this._pendingImages360 = [];

    if (this.scene) {
      this.scene.removeEventListener(
        'pointcloud_added',
        this.onPointcloudAdded
      );
      this.scene.removeEventListener('KML_added', this.onKMLAdded);
      this.scene.removeEventListener('360_images_added', this.on360ImagesAdded);
      // this.scene.annotations.removeEventListener(
      //   'annotation_added',
      //   this.onAnnotationAdded
      // );
    }

    this.scene = scene;

    this.scene.addEventListener('pointcloud_added', this.onPointcloudAdded);
    this.scene.addEventListener('360_images_added', this.on360ImagesAdded);
    this.scene.addEventListener('KML_added', this.onKMLAdded);
    // this.scene.annotations.addEventListener(
    //   'annotation_added',
    //   this.onAnnotationAdded
    // );

    for (let pointcloud of this.viewer.scene.pointclouds) {
      this.load(pointcloud);
    }

    // this.viewer.scene.annotations.traverseDescendants((annotation) => {
    //   this.onAnnotationAdded({ annotation: annotation });
    // });

    for (let images of this.viewer.scene.images360) {
      this.on360ImagesAdded({ images: images });
    }
  }

  getExtentsLayer() {
    if (this.extentsLayer) {
      return this.extentsLayer;
    }

    this.gExtent = new ol.geom.LineString([
      [0, 0],
      [0, 0],
    ]);

    let feature = new ol.Feature(this.gExtent);
    let featureVector = new ol.source.Vector({
      features: [feature],
    });

    this.extentsLayer = new ol.layer.Vector({
      source: featureVector,
      style: new ol.style.Style({
        fill: new ol.style.Fill({
          color: 'rgba(255, 255, 255, 0.2)',
        }),
        stroke: new ol.style.Stroke({
          color: '#0000ff',
          width: 2,
        }),
        image: new ol.style.Circle({
          radius: 3,
          fill: new ol.style.Fill({
            color: '#0000ff',
          }),
        }),
      }),
    });

    return this.extentsLayer;
  }

  // getAnnotationsLayer() {
  //   if (this.annotationsLayer) {
  //     return this.annotationsLayer;
  //   }

  //   this.annotationsLayer = new ol.layer.Vector({
  //     source: new ol.source.Vector({}),
  //     style: new ol.style.Style({
  //       fill: new ol.style.Fill({
  //         color: 'rgba(255, 0, 0, 1)',
  //       }),
  //       stroke: new ol.style.Stroke({
  //         color: 'rgba(255, 0, 0, 1)',
  //         width: 2,
  //       }),
  //     }),
  //   });

  //   return this.annotationsLayer;
  // }

  getCameraLayer() {
    if (this.cameraLayer) {
      return this.cameraLayer;
    }

    // CAMERA LAYER
    this.gCamera = new ol.geom.LineString([
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
    ]);
    let feature = new ol.Feature(this.gCamera);
    let featureVector = new ol.source.Vector({
      features: [feature],
    });

    this.cameraLayer = new ol.layer.Vector({
      source: featureVector,
      style: new ol.style.Style({
        stroke: new ol.style.Stroke({
          color: '#0000ff',
          width: 2,
        }),
      }),
    });

    return this.cameraLayer;
  }

  getToolLayer() {
    if (this.toolLayer) {
      return this.toolLayer;
    }

    this.toolLayer = new ol.layer.Vector({
      source: new ol.source.Vector({}),
      style: new ol.style.Style({
        fill: new ol.style.Fill({
          color: 'rgba(255, 0, 0, 1)',
        }),
        stroke: new ol.style.Stroke({
          color: 'rgba(255, 0, 0, 1)',
          width: 2,
        }),
      }),
    });

    return this.toolLayer;
  }

  getImages360Layer() {
    if (this.images360Layer) {
      return this.images360Layer;
    }
    let style = new ol.style.Style({
      image: new ol.style.Circle({
        radius: 4,
        stroke: new ol.style.Stroke({
          color: [255, 0, 0, 1],
          width: 2,
        }),
        fill: new ol.style.Fill({
          color: [255, 100, 100, 1],
        }),
      }),
    });

    let layer = new ol.layer.Vector({
      source: new ol.source.Vector({}),
      style: style,
    });
    layer.setZIndex(100);
    this.images360Layer = layer;
    return this.images360Layer;
  }

  getKMLLayer() {
    if (this.KMLLayer) {
      return this.KMLLayer;
    }
    let layer = new ol.layer.Vector({
      source: new ol.source.Vector({}),
    });

    this.KMLLayer = layer;
    return this.KMLLayer;
  }

  setKMLLayerSource(url) {
    let layer = new ol.layer.Vector({
      source: new ol.source.Vector({
        url: url,
        format: new ol.format.KML(),
      }),
    });
    this.map.getLayers().push(layer);
    this.KMLLayer = layer;
  }

  getSourcesLayer() {
    if (this.sourcesLayer) {
      return this.sourcesLayer;
    }

    this.sourcesLayer = new ol.layer.Vector({
      source: new ol.source.Vector({}),
      style: new ol.style.Style({
        fill: new ol.style.Fill({
          color: 'rgba(0, 0, 150, 0.1)',
        }),
        stroke: new ol.style.Stroke({
          color: 'rgba(0, 0, 150, 1)',
          width: 1,
        }),
      }),
    });

    return this.sourcesLayer;
  }

  getSourcesLabelLayer() {
    if (this.sourcesLabelLayer) {
      return this.sourcesLabelLayer;
    }

    this.sourcesLabelLayer = new ol.layer.Vector({
      source: new ol.source.Vector({}),
      style: new ol.style.Style({
        fill: new ol.style.Fill({
          color: 'rgba(255, 0, 0, 0.1)',
        }),
        stroke: new ol.style.Stroke({
          color: 'rgba(255, 0, 0, 1)',
          width: 2,
        }),
      }),
      minResolution: 0.01,
      maxResolution: 20,
    });

    return this.sourcesLabelLayer;
  }

  setSceneProjection(sceneProjection) {
    // Resolve the transforms FIRST. proj4() throws on an unparseable
    // projection (e.g. a WKT2 string); if it does, leave sceneProjection/toMap
    // unset so the host can fall back (setLocalMode) instead of being stuck in
    // a half-configured state (sceneProjection set, toMap null) where the
    // pending-360-images queue can never flush.
    const toMap = proj4(sceneProjection, this.mapProjection);
    const toScene = proj4(this.mapProjection, sceneProjection);
    this.sceneProjection = sceneProjection;
    this.localMode = false;
    this.toMap = toMap;
    this.toScene = toScene;
    this._mapPanels?.showButton('wms', true);
    this._flushPendingImages360();
  }

  /** Add any 360-image sets that arrived before a projection mode was set. */
  _flushPendingImages360() {
    if (!this._pendingImages360 || !this.toMap) return;
    const pending = this._pendingImages360;
    this._pendingImages360 = [];
    for (const images of pending) {
      this.addImages360(images);
    }
  }

  /**
   * Switch the map into local (non-georeferenced) mode: identity transforms,
   * OSM tiles hidden, neutral gray background. Floor plans and panoramas still
   * work because their coordinates stay in scene space.
   */
  setLocalMode() {
    const identity = (coords) => [coords[0], coords[1]];
    this.sceneProjection = 'LOCAL';
    this.localMode = true;
    this.toMap = { forward: identity, inverse: identity };
    this.toScene = { forward: identity, inverse: identity };

    this._mapPanels?.showButton('wms', false);

    if (this.map) {
      const layers = this.map.getLayers().getArray();
      if (layers[0]) {
        layers[0].setVisible(false);
      }

      const mapEl = document.getElementById('potree_map_content');
      if (mapEl) {
        mapEl.style.backgroundColor = '#e0e0e0';
      }

      const mousePos = this.map.getControls().getArray()
        .find((c) => c instanceof ol.control.MousePosition);
      if (mousePos) {
        this.map.removeControl(mousePos);
      }
    }

    this._flushPendingImages360();
  }

  getMapExtent() {
    let bb = this.viewer.getBoundingBox();

    let bottomLeft = this.toMap.forward([bb.min.x, bb.min.y]);
    let bottomRight = this.toMap.forward([bb.max.x, bb.min.y]);
    let topRight = this.toMap.forward([bb.max.x, bb.max.y]);
    let topLeft = this.toMap.forward([bb.min.x, bb.max.y]);

    if (
      !isFinite(bottomLeft[0]) || !isFinite(bottomLeft[1]) ||
      !isFinite(topRight[0]) || !isFinite(topRight[1])
    ) {
      return null;
    }

    let extent = {
      bottomLeft: bottomLeft,
      bottomRight: bottomRight,
      topRight: topRight,
      topLeft: topLeft,
    };

    return extent;
  }

  getMapCenter() {
    let mapExtent = this.getMapExtent();
    if (!mapExtent) return null;

    let mapCenter = [
      (mapExtent.bottomLeft[0] + mapExtent.topRight[0]) / 2,
      (mapExtent.bottomLeft[1] + mapExtent.topRight[1]) / 2,
    ];

    if (!isFinite(mapCenter[0]) || !isFinite(mapCenter[1])) return null;
    return mapCenter;
  }

  updateToolDrawings() {
    this.toolLayer.getSource().clear();

    let profiles = this.viewer.profileTool.profiles;
    for (let i = 0; i < profiles.length; i++) {
      let profile = profiles[i];
      let coordinates = [];

      for (let j = 0; j < profile.points.length; j++) {
        let point = profile.points[j];
        let pointMap = this.toMap.forward([point.x, point.y]);
        coordinates.push(pointMap);
      }

      let line = new ol.geom.LineString(coordinates);
      let feature = new ol.Feature(line);
      this.toolLayer.getSource().addFeature(feature);
    }

    let measurements = this.viewer.measuringTool.measurements;
    for (let i = 0; i < measurements.length; i++) {
      let measurement = measurements[i];
      let coordinates = [];

      for (let j = 0; j < measurement.points.length; j++) {
        let point = measurement.points[j].position;
        let pointMap = this.toMap.forward([point.x, point.y]);
        coordinates.push(pointMap);
      }

      if (measurement.closed && measurement.points.length > 0) {
        coordinates.push(coordinates[0]);
      }

      let line = new ol.geom.LineString(coordinates);
      let feature = new ol.Feature(line);
      this.toolLayer.getSource().addFeature(feature);
    }
  }

  addImages360(images) {
    if (!this.toMap) {
      // Map projection mode not resolved yet (setSceneProjection/setLocalMode
      // hasn't run — common on local-CRS sites where panoramas can land
      // before the host configures the map). Queue and flush once a mode is
      // set: throwing here used to propagate through Scene's
      // 360_images_added dispatch and abort the host's panorama loading loop,
      // so only the first set (or none) would appear in the viewer.
      this._pendingImages360 = this._pendingImages360 || [];
      this._pendingImages360.push(images);
      return;
    }
    let transform = this.toMap.forward;
    let layer = this.getImages360Layer();

    let names = [];
    for (let image of images.images) {
      if (!names.includes(image.name)) {
        names.push(image.name);
      }
    }

    let minHeight = 100000,
      maxHeight = -100000;

    for (let image of images.images) {
      if (image.position[2] > maxHeight) {
        maxHeight = image.position[2];
      }
      if (image.position[2] < minHeight) {
        minHeight = image.position[2];
      }
    }

    let heightRange = maxHeight - minHeight;
    if (!isFinite(heightRange) || heightRange === 0) heightRange = 1;
    let b = Math.floor(Math.random() * 256 + 50);
    for (let image of images.images) {
      let r = Math.floor(255 * ((image.position[2] - minHeight) / heightRange));
      let g = Math.floor(255 * ((maxHeight - image.position[2]) / heightRange));

      let p = transform([image.position[0], image.position[1]]);
      if (!isFinite(p[0]) || !isFinite(p[1])) continue;

      let feature = new ol.Feature({
        geometry: new ol.geom.Point(p),
      });

      // Zapisz referencję do image i images360 dla łatwego czyszczenia
      feature.set('image360', image);
      feature.set('images360', images);

      feature.onClick = () => {
        images.focusPoint(image, feature);
      };
      feature.setStyle(
        new ol.style.Style({
          image: new ol.style.Circle({
            radius: 4,
            stroke: new ol.style.Stroke({
              color: [0, 0, 0, 1],
              width: 0.5,
            }),
            fill: new ol.style.Fill({
              color: [r, g, b, 1],
            }),
          }),
        })
      );

      layer.getSource().addFeature(feature);
      if (image.isHidden === undefined || !image.isHidden) {
        showFeature(feature, r, g, b);
      } else {
        if (!images.getEditModeChecked()) {
          hideFeature(feature);
        }
      }
      images.addEventListener('hidden-image', function (event) {
        if (event.image === image) {
          if (!images.getEditModeChecked()) {
            hideFeature(feature);
          }
        }
      });
      images.addEventListener('unhide-image', function (event) {
        if (event.image === image) {
          showFeature(feature, r, g, b);
        }
      });
    }

    function hideFeature(feature) {
      feature.setStyle(
        new ol.style.Style({
          image: new ol.style.Circle({
            radius: 0,
            stroke: new ol.style.Stroke({
              color: [0, 0, 0, 0],
              width: 0,
            }),
            fill: new ol.style.Fill({
              color: [0, 0, 0, 0],
            }),
          }),
        })
      );
    }

    function showFeature(feature, r, g, b) {
      feature.setStyle(
        new ol.style.Style({
          image: new ol.style.Circle({
            radius: 4,
            stroke: new ol.style.Stroke({
              color: [0, 0, 0, 1],
              width: 0.5,
            }),
            fill: new ol.style.Fill({
              color: [r, g, b, 1],
            }),
          }),
        })
      );
    }
  }

  async load(pointcloud) {
    if (!pointcloud) {
      return;
    }

    if (!this.sceneProjection) {
      let proj = pointcloud.projection || pointcloud.fallbackProjection;
      if (!proj) { return; }
      try {
        this.setSceneProjection(proj);
      } catch (e) {
        return;
      }
    }

    let mapExtent = this.getMapExtent();
    let mapCenter = this.getMapCenter();

    if (!mapExtent || !mapCenter) {
      return;
    }

    let view = this.map.getView();
    view.setCenter(mapCenter);

    this.gExtent.setCoordinates([
      mapExtent.bottomLeft,
      mapExtent.bottomRight,
      mapExtent.topRight,
      mapExtent.topLeft,
      mapExtent.bottomLeft,
    ]);

    view.fit(this.gExtent, [300, 300], {
      constrainResolution: false,
    });

    if (pointcloud.pcoGeometry.type == 'ept') {
      return;
    }

    let url = `${pointcloud.pcoGeometry.url}/../sources.json`;
    //let response = await fetch(url);

    // fetch(url)
    //   .then(async (response) => {
    //     let data = await response.json();

    //     let sources = data.sources;

    //     for (let i = 0; i < sources.length; i++) {
    //       let source = sources[i];
    //       let name = source.name;
    //       let bounds = source.bounds;

    //       let mapBounds = {
    //         min: this.toMap.forward([bounds.min[0], bounds.min[1]]),
    //         max: this.toMap.forward([bounds.max[0], bounds.max[1]]),
    //       };
    //       let mapCenter = [
    //         (mapBounds.min[0] + mapBounds.max[0]) / 2,
    //         (mapBounds.min[1] + mapBounds.max[1]) / 2,
    //       ];

    //       let p1 = this.toMap.forward([bounds.min[0], bounds.min[1]]);
    //       let p2 = this.toMap.forward([bounds.max[0], bounds.min[1]]);
    //       let p3 = this.toMap.forward([bounds.max[0], bounds.max[1]]);
    //       let p4 = this.toMap.forward([bounds.min[0], bounds.max[1]]);

    //       // let feature = new ol.Feature({
    //       //	'geometry': new ol.geom.LineString([p1, p2, p3, p4, p1])
    //       // });
    //       let feature = new ol.Feature({
    //         geometry: new ol.geom.Polygon([[p1, p2, p3, p4, p1]]),
    //       });
    //       feature.source = source;
    //       feature.pointcloud = pointcloud;
    //       this.getSourcesLayer().getSource().addFeature(feature);

    //       feature = new ol.Feature({
    //         geometry: new ol.geom.Point(mapCenter),
    //         name: name,
    //       });
    //       feature.setStyle(this.createLabelStyle(name));
    //       this.sourcesLabelLayer.getSource().addFeature(feature);
    //     }
    //   })
    //   .catch(() => {});
  }

  toggle() {
    if (this.elMap.is(':visible')) {
      this.elMap.css('display', 'none');
      this.enabled = false;
    } else {
      this.elMap.css('display', 'flex');
      this.enabled = true;
    }
  }

  update(delta) {
    if (!this.sceneProjection) {
      return;
    }

    let pm = $('#potree_map');

    if (!this.enabled) {
      return;
    }

    if (!this.map) { return; }

    // resize (mapSize can be undefined before the container is laid out)
    let mapSize = this.map.getSize();
    if (mapSize) {
      let resized = pm.width() !== mapSize[0] || pm.height() !== mapSize[1];
      if (resized) {
        this.map.updateSize();
      }
    }

    //
    let camera = this.viewer.scene.getActiveCamera();

    let scale = this.map.getView()?.getResolution();
    if (scale == null || !isFinite(scale)) { return; }
    let campos = camera.position;
    if (!isFinite(campos.x) || !isFinite(campos.y)) { return; }
    let camdir = camera.getWorldDirection(new THREE.Vector3());
    let sceneLookAt = camdir
      .clone()
      .multiplyScalar(30 * scale)
      .add(campos);
    let geoPos = camera.position;
    let geoLookAt = sceneLookAt;
    if (!isFinite(geoLookAt.x) || !isFinite(geoLookAt.y)) { return; }
    let mapPosArr = this.toMap.forward([geoPos.x, geoPos.y]);
    let mapLookAtArr = this.toMap.forward([geoLookAt.x, geoLookAt.y]);
    if (!isFinite(mapPosArr[0]) || !isFinite(mapPosArr[1])) { return; }
    if (!isFinite(mapLookAtArr[0]) || !isFinite(mapLookAtArr[1])) { return; }
    let mapPos = new THREE.Vector2().fromArray(mapPosArr);
    let mapLookAt = new THREE.Vector2().fromArray(mapLookAtArr);
    let mapDir = new THREE.Vector2().subVectors(mapLookAt, mapPos);
    if (mapDir.length() < 1e-10) { return; }
    mapDir.normalize();

    mapLookAt = mapPos.clone().add(mapDir.clone().multiplyScalar(30 * scale));
    let mapLength = mapPos.distanceTo(mapLookAt);
    let mapSide = new THREE.Vector2(-mapDir.y, mapDir.x);

    let p1 = mapPos.toArray();
    let p2 = mapLookAt
      .clone()
      .sub(mapSide.clone().multiplyScalar(0.3 * mapLength))
      .toArray();
    let p3 = mapLookAt
      .clone()
      .add(mapSide.clone().multiplyScalar(0.3 * mapLength))
      .toArray();

    this.gCamera.setCoordinates([p1, p2, p3, p1]);
  }

  get sourcesVisible() {
    return this.getSourcesLayer().getVisible();
  }

  set sourcesVisible(value) {
    this.getSourcesLayer().setVisible(value);
  }

  clearFloorLayers() {
    if (!this.map) return;
    for (let i = this._floorsInserted; i >= 1; i--) {
      const layer = this.map.getLayers().getArray()[i];
      if (layer) {
        this.map.removeLayer(layer);
      }
    }
    this._floorsInserted = 0;
    if (this.floorsGroup?.parentNode) {
      this.floorsGroup.parentNode.removeChild(this.floorsGroup);
    }
    this._mapPanels?.showButton('floors', false);
    this.floorsGroup = null;
    this.floorsList = null;
  }

  rebuildFloorsSelector(floors) {
    const floorsGroup = this.createFloorsOnMap();
    this.floorsGroup = floorsGroup;

    const mapPanels = this._ensureMapPanels();
    if (mapPanels) {
      mapPanels.setPanelContent('floors', floorsGroup, {
        label: 'Rzuty',
        title: 'Rzuty',
        icon: NOACH_MAP_ICON_FLOORS,
      });
      mapPanels.showButton('floors', true);
    } else {
      const element = document.getElementById('download-selection-control');
      if (!element) return;
      element.appendChild(floorsGroup);
    }

    if (!this.floorsList) return;

    // Remove all floor buttons except 'Wszystko'
    this.floorsList
      .querySelectorAll('.noach-map-list-item:not([data-value="all"])')
      .forEach((b) => b.remove());

    for (let i = 0; i < floors.length; i++) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'noach-map-list-item';
      btn.dataset.value = String(i);
      btn.textContent = floors[i].label || `Floor ${i + 1}`;
      btn.addEventListener('click', () => this._selectFloor?.(String(i)));
      this.floorsList.appendChild(btn);
    }
  }

  /**
   * Load floor plan overlays from API config (Noach).
   * @param {Array<{id:string, label:string, imageUrl:string, extent:number[], zMax:number, sortOrder:number}>} floors
   */
  loadFloorsFromConfig(floors) {
    if (!this.map || typeof ol === 'undefined') {
      return;
    }

    this.clearFloorLayers();

    const sorted = [...(floors || [])]
      .filter((f) => f.imageUrl && f.extent && f.extent.length === 4)
      .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));

    const floorsZCeiling = [];

    for (const floor of sorted) {
      floorsZCeiling.push(floor.zMax);
      const imageExtent = floor.extent;
      const imageSource = new ol.source.ImageStatic({
        url: floor.imageUrl,
        imageExtent: imageExtent,
      });
      const imageLayer = new ol.layer.Image({
        source: imageSource,
        name: floor.id || floor.label,
        opacity: 0.85,
      });
      this.map.getLayers().insertAt(1 + this.floorsInserted, imageLayer);
      this.map.getLayers().getArray()[1 + this.floorsInserted].setVisible(false);
      this.floorsInserted = this.floorsInserted + 1;
    }

    if (sorted.length > 0) {
      this.rebuildFloorsSelector(sorted);
    }

    this.map.dispatchEvent({
      type: 'floors-loaded',
      floorsZCeiling: floorsZCeiling,
    });
  }
}

export class MapLoader extends EventDispatcher {
  static async loader(url, mapView) {
    // https://marientall.pl/clouds/panos/test
    let response = await fetch(`${url}/floors.txt`);
    let text = await response.text();
    let lines = text.split(/\r?\n/);
    let floorsZCeiling = [];

    for (let line of lines) {
      if (line.trim().length === 0) {
        continue;
      }
      let tokens = line.split(/\t/);
      let [z, mapUrl] = tokens;
      z = parseFloat(z);
      floorsZCeiling.push(z);
      mapUrl = mapUrl.replace(/"/g, '');
      try {
        const dimensions = await getImageDimensions(mapUrl);
        const extent = await calculateExtent(dimensions, mapUrl);
        const imageExtent = [extent.x1, extent.y1, extent.x2, extent.y2];
        let imageSource = new ol.source.ImageStatic({
          url: mapUrl,
          imageExtent: imageExtent,
        });
        let imageLayer = new ol.layer.Image({
          source: imageSource,
          name: mapUrl,
        });
        mapView.map.getLayers().insertAt(1 + mapView.floorsInserted, imageLayer);
        mapView.map.getLayers().getArray()[1 + mapView.floorsInserted].setVisible(false);
        mapView.floorsInserted = mapView.floorsInserted + 1;
      } catch (error) {
        console.error('Błąd przy ładowaniu obrazu:', error);
      }
    }
    // for (var i = 0; i < mapView.map.getLayers().getArray().length; i++) {
    //   // TODO
    // }
    let floorsGroup = mapView.createFloorsOnMap();
    mapView.floorsGroup = floorsGroup;
    const mapPanels = mapView._ensureMapPanels();
    if (mapPanels) {
      mapPanels.setPanelContent('floors', floorsGroup, {
        label: 'Rzuty',
        title: 'Rzuty',
        icon: NOACH_MAP_ICON_FLOORS,
      });
      mapPanels.showButton('floors', true);
    } else {
      let element = document.getElementById('download-selection-control');
      if (element) element.appendChild(floorsGroup);
    }

    mapView.map.dispatchEvent({
      type: 'floors-loaded',
      floorsZCeiling: floorsZCeiling,
    });
  }

}
async function getImageDimensions(url) {
  const img = new Image();
  img.src = url;

  return new Promise((resolve, reject) => {
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
    img.onerror = (error) => {
      reject(error);
    };
  });
}

async function calculateExtent(dimensions, url) {
  let tfwFileUrl = url.slice(0, -3) + 'tfw';
  let response = await fetch(tfwFileUrl);
  let text = await response.text();
  let lines = text.split(/\r?\n/);
  let x1 = parseFloat(lines[4]);
  let y1 = parseFloat(lines[5]) + dimensions.height * parseFloat(lines[3]);
  let x2 = parseFloat(lines[4]) + dimensions.width * parseFloat(lines[0]);
  let y2 = parseFloat(lines[5]);
  return {
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2
  }
}
